const createjs = require("createjs/builds/1.0.0/createjs");

let AdobeAn;

(function (cjs, an, img = {}) {

    var p; // shortcut to reference prototypes
    var lib = {}; var ss = {}; var img = {};
    lib.ssMetadata = [];


    (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;
        this.gotoAndPlay = function (positionOrLabel) {
            cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };
        this.play = function () {
            cjs.MovieClip.prototype.play.call(this);
        };
        this.gotoAndStop = function (positionOrLabel) {
            cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };
        this.stop = function () {
            cjs.MovieClip.prototype.stop.call(this);
        };
    }).prototype = p = new cjs.MovieClip();
    // symbols:



    (lib.coinsresultx2 = function () {
        this.initialize(img.coinsresultx2);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 579, 136);


    (lib.sharebackground = function () {
        this.initialize(img.sharebackground);
    }).prototype = p = new cjs.Bitmap();
    p.nominalBounds = new cjs.Rectangle(0, 0, 2400, 1260);// helper functions:

    function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }


    (lib.titlemc = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FFFFFF").s().p("Ag9DbIAAl2Ih9AAIAAg/IF2AAIAAA/Ih9AAIAAF2g");
        this.shape.setTransform(425, 21.875);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics.f("#FFFFFF").s().p("ABeDbIAAh9Ii7AAIAAB9Ih9AAIAAk4IA/AAIAAg+IA+AAIAAg/IC7AAIAAA/IA+AAIAAA+IA/AAIAAE4gAhdAfIC7AAIAAh8Ig/AAIAAg+Ig9AAIAAA+Ig/AAg");
        this.shape_1.setTransform(371.875, 21.875);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics.f("#FFFFFF").s().p("Ag9DbIAAl2Ih9AAIAAg/IF1AAIAAA/Ih8AAIAAF2g");
        this.shape_2.setTransform(325, 21.875);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics.f("#FFFFFF").s().p("AjaDbIAAm1IB9AAIAAB9ID5AAIAAA/IA/AAIAAC6Ig/AAIAAA/gAhdCcIC7AAIAAi6Ii7AAg");
        this.shape_3.setTransform(271.875, 21.875);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics.f("#FFFFFF").s().p("ABeDbIAAl2Ih8AAIAAE3Ig/AAIAAA/Ih9AAIAAh9IA/AAIAAg/IA+AAIAAj5IE4AAIAAG1g");
        this.shape_4.setTransform(221.875, 21.875);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics.f("#FFFFFF").s().p("AibDbIAAg/Ig/AAIAAg+IB9AAIAAA+IC7AAIAAh9Ij5AAIAAg9Ig/AAIAAi8IB9AAIAAC8IC7AAIAAi8IB9AAIAAF2Ig/AAIAAA/g");
        this.shape_5.setTransform(171.875, 21.875);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics.f("#FFFFFF").s().p("AibDbIAAg/Ig/AAIAAg+IB9AAIAAA+IC7AAIAAh9Ii7AAIAAg9IC7AAIAAh9Ii7AAIAAA+Ih9AAIAAg+IA/AAIAAg/IE3AAIAAA/IA/AAIAAB9Ig/AAIAAA9IA/AAIAAB9Ig/AAIAAA/g");
        this.shape_6.setTransform(121.875, 21.875);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics.f("#FFFFFF").s().p("AjaDbIAAm1IG1AAIAAA/Ik4AAIAAB9ID5AAIAAA9Ij5AAIAAB9IE4AAIAAA/g");
        this.shape_7.setTransform(71.875, 21.875);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics.f("#FFFFFF").s().p("AjaDbIAAm1IF2AAIAAA/IA/AAIAAC6Ig/AAIAAA/Ij5AAIAAB9gAhdAfIC7AAIAAi6Ii7AAg");
        this.shape_8.setTransform(21.875, 21.875);

        this.timeline.addTween(cjs.Tween.get({}).to({ state: [{ t: this.shape_8 }, { t: this.shape_7 }, { t: this.shape_6 }, { t: this.shape_5 }, { t: this.shape_4 }, { t: this.shape_3 }, { t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }] }).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.titlemc, new cjs.Rectangle(0, 0, 443.8, 43.8), null);


    (lib.Symbol1 = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.bf(img.coinsresultx2, null, new cjs.Matrix2D(0.5, 0, 0, 0.5, -25.5, -34)).s().p("Aj+FUIAAqnIH9AAIAAKng");
        this.shape.setTransform(25.5, 34);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(0, 0, 51, 68), null);


    (lib.text9999 = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FFFFFF").s().p("AgdBGIAAgUIAnAAIAAAUgAgdAeIAAhjIA7AAIAAA8IgUAAIAAAng");
        this.shape.setTransform(191, 28);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_1.setTransform(175, 30);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_2.setTransform(159, 30);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_3.setTransform(143, 30);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_4.setTransform(127, 31);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics.f("#FFFFFF").s().p("AhFBGIAAiLIB3AAIAAAUIhPAAIAAAoIBPAAIAAATIAUAAIAAAoIgUAAIAAAUgAgdAyIA7AAIAAgoIg7AAg");
        this.shape_5.setTransform(111, 28);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics.f("#FFFFFF").s().p("AgdBGIAAgUIAnAAIAAAUgAgdAeIAAhjIA7AAIAAA8IgUAAIAAAng");
        this.shape_6.setTransform(295, 7);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAgoIAUAAIAAgTIgUAAIAAgUIAUAAIAAgUIB3AAIAABjgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_7.setTransform(279, 9);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_8.setTransform(263, 9);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics.f("#FFFFFF").s().p("AAeA8IAAgUIhjAAIAAhjIAoAAIAABPIAnAAIAAhPIAoAAIAABPIAUAAIAAAog");
        this.shape_9.setTransform(247, 10);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_10.setTransform(231, 9);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAoAAIAAAUIA7AAIAAgUIgnAAIAAgTIAnAAIAAgUIg7AAIAAAUIgoAAIAAgUIAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUg");
        this.shape_11.setTransform(215, 9);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_12.setTransform(199, 9);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_13.setTransform(183, 9);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_14.setTransform(167, 9);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_15.setTransform(151, 9);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_16.setTransform(135, 10);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_17.setTransform(103, 9);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_18.setTransform(88, 9);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAoAAIAAAUIA7AAIAAgUIgnAAIAAgTIAnAAIAAgUIg7AAIAAAUIgoAAIAAgUIAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUg");
        this.shape_19.setTransform(71, 9);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_20.setTransform(40, 9);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_21.setTransform(23, 9);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics.f("#FFFFFF").s().p("AhFBGIAAiLIB3AAIAAAUIAUAAIAAAoIgUAAIAAATIAUAAIAAAoIgUAAIAAAUgAgdAyIA7AAIAAgoIg7AAgAgdgJIA7AAIAAgoIg7AAg");
        this.shape_22.setTransform(7, 7);

        this.timeline.addTween(cjs.Tween.get({}).to({ state: [{ t: this.shape_22 }, { t: this.shape_21 }, { t: this.shape_20 }, { t: this.shape_19 }, { t: this.shape_18 }, { t: this.shape_17 }, { t: this.shape_16 }, { t: this.shape_15 }, { t: this.shape_14 }, { t: this.shape_13 }, { t: this.shape_12 }, { t: this.shape_11 }, { t: this.shape_10 }, { t: this.shape_9 }, { t: this.shape_8 }, { t: this.shape_7 }, { t: this.shape_6 }, { t: this.shape_5 }, { t: this.shape_4 }, { t: this.shape_3 }, { t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }] }).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.text9999, new cjs.Rectangle(0, 0, 298, 37), null);


    (lib.text999 = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FFFFFF").s().p("AgdBGIAAgUIAnAAIAAAUgAgdAeIAAhjIA7AAIAAA8IgUAAIAAAng");
        this.shape.setTransform(279, 28);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics.f("#FFFFFF").s().p("AAeAyIAAhjIAoAAIAABjgAhFAyIAAhjIAoAAIAAAoIAnAAIAAA7gAgdAeIAUAAIAAgUIgUAAg");
        this.shape_1.setTransform(263, 30);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_2.setTransform(248, 30);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAAAoIBPAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_3.setTransform(215, 30);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAABPIAUAAIAAhPIATAAIAABPIAUAAIAAhPIAoAAIAABjg");
        this.shape_4.setTransform(199, 30);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_5.setTransform(183, 30);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_6.setTransform(167, 30);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics.f("#FFFFFF").s().p("AAoA8IAAgUIhPAAIAAAUIgoAAIAAgoIAUAAIAAgUIAUAAIAAg7IBjAAIAABPIAUAAIAAAogAgTAUIAnAAIAAg7IgnAAg");
        this.shape_7.setTransform(152, 31);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIgUAAIAAAoIgTAAIAAgoIgUAAIAAAoIgoAAIAAgoIAUAAIAAgTIgUAAIAAgoIAoAAIAAAoIAUAAIAAgoIATAAIAAAoIAUAAIAAgoIAoAAIAAAoIgUAAIAAATIAUAAIAAAog");
        this.shape_8.setTransform(135, 30);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_9.setTransform(119, 30);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics.f("#FFFFFF").s().p("AgxBGIAAgUIgUAAIAAhjIAUAAIAAgUIB3AAIAAAUIhjAAIAAAoIAUAAIAAATIgUAAIAAAoIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUg");
        this.shape_10.setTransform(103, 28);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_11.setTransform(87, 30);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIg7AAIAABPIgoAAIAAhjICLAAIAABjg");
        this.shape_12.setTransform(71, 30);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_13.setTransform(39, 30);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics.f("#FFFFFF").s().p("AgdAeIAAgUIAUAAIAAgnIAnAAIAAAnIgUAAIAAAUg");
        this.shape_14.setTransform(309, 13);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_15.setTransform(295, 9);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_16.setTransform(279, 9);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_17.setTransform(263, 9);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_18.setTransform(232, 9);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics.f("#FFFFFF").s().p("AgJAyIAAgUIgUAAIAAgUIgUAAIAAAoIgUAAIAAhjIAUAAIAAAoIAUAAIAAgUIAUAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUgAAKAeIAUAAIAAg7IgUAAg");
        this.shape_19.setTransform(215, 9);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_20.setTransform(199, 9);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_21.setTransform(183, 10);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics.f("#FFFFFF").s().p("Ag7AyIAAhjIB3AAIAAAoIgUAAIAAgUIg7AAIAABPg");
        this.shape_22.setTransform(168, 9);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_23.setTransform(151, 9);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_24.setTransform(119, 9);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_25.setTransform(103, 9);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics.f("#FFFFFF").s().p("AgxBGIAAgUIgUAAIAAhjIAUAAIAAgUIB3AAIAAAUIhjAAIAAAoIAUAAIAAATIgUAAIAAAoIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUg");
        this.shape_26.setTransform(87, 7);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_27.setTransform(72, 9);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics.f("#FFFFFF").s().p("AgxA8IAAgUIBPAAIAAgUIhPAAIAAgUIgUAAIAAg7IAoAAIAAA7IA7AAIAAg7IAoAAIAABjIgUAAIAAAUg");
        this.shape_28.setTransform(55, 10);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics.f("#FFFFFF").s().p("AgJBGIAAgUIgoAAIAAgUIgUAAIAAg7IAUAAIAAgUIAoAAIAAgUIATAAIAAAUIAoAAIAAAUIAUAAIAAA7IgUAAIAAAUIgoAAIAAAUgAAKAeIAUAAIAAg7IgUAAgAgdAeIAUAAIAAg7IgUAAg");
        this.shape_29.setTransform(39, 9);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics.f("#FFFFFF").s().p("AhFBGIAAiLIB3AAIAAAUIAUAAIAAAoIgUAAIAAATIAUAAIAAAoIgUAAIAAAUgAgdAyIA7AAIAAgoIg7AAgAgdgJIA7AAIAAgoIg7AAg");
        this.shape_30.setTransform(7, 7);

        this.timeline.addTween(cjs.Tween.get({}).to({ state: [{ t: this.shape_30 }, { t: this.shape_29 }, { t: this.shape_28 }, { t: this.shape_27 }, { t: this.shape_26 }, { t: this.shape_25 }, { t: this.shape_24 }, { t: this.shape_23 }, { t: this.shape_22 }, { t: this.shape_21 }, { t: this.shape_20 }, { t: this.shape_19 }, { t: this.shape_18 }, { t: this.shape_17 }, { t: this.shape_16 }, { t: this.shape_15 }, { t: this.shape_14 }, { t: this.shape_13 }, { t: this.shape_12 }, { t: this.shape_11 }, { t: this.shape_10 }, { t: this.shape_9 }, { t: this.shape_8 }, { t: this.shape_7 }, { t: this.shape_6 }, { t: this.shape_5 }, { t: this.shape_4 }, { t: this.shape_3 }, { t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }] }).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.text999, new cjs.Rectangle(0, 0, 312, 37), null);


    (lib.text99 = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape.setTransform(279, 51);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_1.setTransform(263, 51);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_2.setTransform(247, 51);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAAAoIBPAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_3.setTransform(231, 51);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_4.setTransform(215, 51);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_5.setTransform(199, 51);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_6.setTransform(183, 51);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAgoIAUAAIAAgTIgUAAIAAgUIAUAAIAAgUIB3AAIAABjgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_7.setTransform(151, 51);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_8.setTransform(135, 51);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_9.setTransform(119, 51);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_10.setTransform(103, 51);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAoAAIAAAUIA7AAIAAgUIgnAAIAAgTIAnAAIAAgUIg7AAIAAAUIgoAAIAAgUIAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUg");
        this.shape_11.setTransform(87, 51);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_12.setTransform(71, 51);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIAnAAIAAgUIAUAAIAAAUIAUAAIAAATIAUAAIAAAogAAegdIAAgUIAoAAIAAAUgAAegdg");
        this.shape_13.setTransform(55, 51);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_14.setTransform(39, 51);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics.f("#FFFFFF").s().p("AAeAyIAAhjIAoAAIAABjgAhFAyIAAhjIAoAAIAAAoIAnAAIAAA7gAgdAeIAUAAIAAgUIgUAAg");
        this.shape_15.setTransform(311, 30);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_16.setTransform(296, 30);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_17.setTransform(263, 30);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_18.setTransform(247, 30);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics.f("#FFFFFF").s().p("AgdAeIAAgUIAUAAIAAgnIAnAAIAAAnIgUAAIAAAUg");
        this.shape_19.setTransform(213, 34);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_20.setTransform(199, 30);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_21.setTransform(183, 30);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_22.setTransform(167, 30);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_23.setTransform(151, 30);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_24.setTransform(135, 30);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics.f("#FFFFFF").s().p("Ag7AyIAAhjIB3AAIAAAoIgUAAIAAgUIg7AAIAABPg");
        this.shape_25.setTransform(120, 30);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_26.setTransform(103, 30);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_27.setTransform(87, 30);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_28.setTransform(71, 30);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_29.setTransform(55, 30);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_30.setTransform(39, 30);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_31.setTransform(23, 31);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIg7AAIAABPIgoAAIAAhjICLAAIAABjg");
        this.shape_32.setTransform(7, 30);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_33.setTransform(223, 9);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIAnAAIAAgUIAUAAIAAAUIAUAAIAAATIAUAAIAAAogAAegdIAAgUIAoAAIAAAUgAAegdg");
        this.shape_34.setTransform(207, 9);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAgJAKg");
        this.shape_35.setTransform(191, 9);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_36.setTransform(175, 9);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_37.setTransform(159, 10);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_38.setTransform(143, 9);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIg7AAIAABPIgoAAIAAhjICLAAIAABjg");
        this.shape_39.setTransform(127, 9);

        this.shape_40 = new cjs.Shape();
        this.shape_40.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_40.setTransform(111, 9);

        this.shape_41 = new cjs.Shape();
        this.shape_41.graphics.f("#FFFFFF").s().p("AgdBGIAAgUIgUAAIAAgUIgUAAIAAg7IAUAAIAAgUIAUAAIAAgUIBPAAIAAAUIAUAAIAAAUIgoAAIAAgUIgnAAIAAAUIgUAAIAAA7IAUAAIAAAUIAnAAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_41.setTransform(95, 7);

        this.timeline.addTween(cjs.Tween.get({}).to({ state: [{ t: this.shape_41 }, { t: this.shape_40 }, { t: this.shape_39 }, { t: this.shape_38 }, { t: this.shape_37 }, { t: this.shape_36 }, { t: this.shape_35 }, { t: this.shape_34 }, { t: this.shape_33 }, { t: this.shape_32 }, { t: this.shape_31 }, { t: this.shape_30 }, { t: this.shape_29 }, { t: this.shape_28 }, { t: this.shape_27 }, { t: this.shape_26 }, { t: this.shape_25 }, { t: this.shape_24 }, { t: this.shape_23 }, { t: this.shape_22 }, { t: this.shape_21 }, { t: this.shape_20 }, { t: this.shape_19 }, { t: this.shape_18 }, { t: this.shape_17 }, { t: this.shape_16 }, { t: this.shape_15 }, { t: this.shape_14 }, { t: this.shape_13 }, { t: this.shape_12 }, { t: this.shape_11 }, { t: this.shape_10 }, { t: this.shape_9 }, { t: this.shape_8 }, { t: this.shape_7 }, { t: this.shape_6 }, { t: this.shape_5 }, { t: this.shape_4 }, { t: this.shape_3 }, { t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }] }).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.text99, new cjs.Rectangle(0, 0, 318, 56), null);


    (lib.text09 = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape.setTransform(263, 51);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAgJAKg");
        this.shape_1.setTransform(247, 51);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_2.setTransform(231, 51);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_3.setTransform(215, 51);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_4.setTransform(199, 51);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_5.setTransform(183, 51);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_6.setTransform(167, 51);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_7.setTransform(151, 52);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIg7AAIAABPIgoAAIAAhjICLAAIAABjg");
        this.shape_8.setTransform(135, 51);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_9.setTransform(119, 51);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_10.setTransform(103, 51);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAAUIAUAAIAAAUIgUAAIAAA7gAgJAeIAAgnIATAAIAAAng");
        this.shape_11.setTransform(359, 30);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_12.setTransform(343, 30);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics.f("#FFFFFF").s().p("AAeAyIAAgoIg7AAIAAAoIgoAAIAAhjIAoAAIAAAoIA7AAIAAgoIAoAAIAABjg");
        this.shape_13.setTransform(327, 30);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAAAoIBPAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_14.setTransform(311, 30);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_15.setTransform(295, 30);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_16.setTransform(279, 30);

        this.shape_17 = new cjs.Shape();
        this.shape_17.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_17.setTransform(263, 30);

        this.shape_18 = new cjs.Shape();
        this.shape_18.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAgUIAUAAIAAgTIBPAAIAAgUIhPAAIAAgUIBjAAIAAAUIAUAAIAABPgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_18.setTransform(247, 30);

        this.shape_19 = new cjs.Shape();
        this.shape_19.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_19.setTransform(231, 31);

        this.shape_20 = new cjs.Shape();
        this.shape_20.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIg7AAIAABPIgoAAIAAhjICLAAIAABjg");
        this.shape_20.setTransform(215, 30);

        this.shape_21 = new cjs.Shape();
        this.shape_21.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIB3AAIAAAUIAUAAIAAAUIgUAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_21.setTransform(183, 30);

        this.shape_22 = new cjs.Shape();
        this.shape_22.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAAAoIBPAAIAAATIAUAAIAAAUIgUAAIAAAUgAgdAeIA7AAIAAgUIg7AAg");
        this.shape_22.setTransform(151, 30);

        this.shape_23 = new cjs.Shape();
        this.shape_23.graphics.f("#FFFFFF").s().p("AhFAyIAAhjIAoAAIAABPIAUAAIAAhPIATAAIAABPIAUAAIAAhPIAoAAIAABjg");
        this.shape_23.setTransform(135, 30);

        this.shape_24 = new cjs.Shape();
        this.shape_24.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAnIhjAAIAAAUIBPAAIAAAUgAgdgJIA7AAIAAgUIg7AAg");
        this.shape_24.setTransform(119, 30);

        this.shape_25 = new cjs.Shape();
        this.shape_25.graphics.f("#FFFFFF").s().p("AAoA8IAAgUIhPAAIAAAUIgoAAIAAgoIAUAAIAAgUIAUAAIAAg7IBjAAIAABPIAUAAIAAAogAgTAUIAnAAIAAg7IgnAAg");
        this.shape_25.setTransform(104, 31);

        this.shape_26 = new cjs.Shape();
        this.shape_26.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_26.setTransform(87, 30);

        this.shape_27 = new cjs.Shape();
        this.shape_27.graphics.f("#FFFFFF").s().p("AAeAyIAAhjIAoAAIAABjgAhFAyIAAhjIAoAAIAAAoIAnAAIAAA7gAgdAeIAUAAIAAgUIgUAAg");
        this.shape_27.setTransform(55, 30);

        this.shape_28 = new cjs.Shape();
        this.shape_28.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_28.setTransform(40, 30);

        this.shape_29 = new cjs.Shape();
        this.shape_29.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_29.setTransform(7, 30);

        this.shape_30 = new cjs.Shape();
        this.shape_30.graphics.f("#FFFFFF").s().p("AgdAeIAAgUIAUAAIAAgnIAnAAIAAAnIgUAAIAAAUg");
        this.shape_30.setTransform(341, 13);

        this.shape_31 = new cjs.Shape();
        this.shape_31.graphics.f("#FFFFFF").s().p("AAeBGIAAg8IgUAAIAAgTIAUAAIAAgUIAoAAIAABjgAhFBGIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAeIAAgUIATAAIAAAUgAAKAKgAgxgxIAAgUIBjAAIAAAUg");
        this.shape_31.setTransform(327, 7);

        this.shape_32 = new cjs.Shape();
        this.shape_32.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_32.setTransform(311, 9);

        this.shape_33 = new cjs.Shape();
        this.shape_33.graphics.f("#FFFFFF").s().p("AAoA8IAAgUIh3AAIAAhjIAoAAIAABPIAUAAIAAhPIATAAIAABPIAUAAIAAhPIAoAAIAABPIAUAAIAAAog");
        this.shape_33.setTransform(296, 10);

        this.shape_34 = new cjs.Shape();
        this.shape_34.graphics.f("#FFFFFF").s().p("AgxA8IAAgUIBPAAIAAgUIhPAAIAAgUIgUAAIAAg7IAoAAIAAA7IA7AAIAAg7IAoAAIAABjIgUAAIAAAUg");
        this.shape_34.setTransform(279, 10);

        this.shape_35 = new cjs.Shape();
        this.shape_35.graphics.f("#FFFFFF").s().p("AAoA8IAAgUIhPAAIAAAUIgoAAIAAgoIAUAAIAAgUIAUAAIAAg7IBjAAIAABPIAUAAIAAAogAgTAUIAnAAIAAg7IgnAAg");
        this.shape_35.setTransform(264, 10);

        this.shape_36 = new cjs.Shape();
        this.shape_36.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_36.setTransform(247, 9);

        this.shape_37 = new cjs.Shape();
        this.shape_37.graphics.f("#FFFFFF").s().p("AgTAyIAAhPIgoAAIAAgUIB3AAIAAAUIgoAAIAABPg");
        this.shape_37.setTransform(216, 9);

        this.shape_38 = new cjs.Shape();
        this.shape_38.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAAKgJg");
        this.shape_38.setTransform(199, 9);

        this.shape_39 = new cjs.Shape();
        this.shape_39.graphics.f("#FFFFFF").s().p("AAeAyIAAhPIgnAAIAAA7IgUAAIAAAUIgoAAIAAgoIAUAAIAAgTIAUAAIAAgoIBjAAIAABjg");
        this.shape_39.setTransform(183, 9);

        this.shape_40 = new cjs.Shape();
        this.shape_40.graphics.f("#FFFFFF").s().p("AAeAyIAAg7IgUAAIAAgUIAUAAIAAgUIAoAAIAABjgAhFAyIAAhjIAoAAIAAA7IAUAAIAAAUIgUAAIAAAUgAgJAKIAAgTIATAAIAAATgAgJAKg");
        this.shape_40.setTransform(167, 9);

        this.shape_41 = new cjs.Shape();
        this.shape_41.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAAUIgoAAIAAgUIg7AAIAAA7IA7AAIAAgUIAoAAIAAAUIgUAAIAAAUg");
        this.shape_41.setTransform(151, 9);

        this.shape_42 = new cjs.Shape();
        this.shape_42.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_42.setTransform(135, 9);

        this.shape_43 = new cjs.Shape();
        this.shape_43.graphics.f("#FFFFFF").s().p("AgxA8IAAgUIBPAAIAAgUIhPAAIAAgUIgUAAIAAg7IAoAAIAAA7IA7AAIAAg7IAoAAIAABjIgUAAIAAAUg");
        this.shape_43.setTransform(103, 10);

        this.shape_44 = new cjs.Shape();
        this.shape_44.graphics.f("#FFFFFF").s().p("Ag7AyIAAhjIB3AAIAAAoIgUAAIAAgUIg7AAIAABPg");
        this.shape_44.setTransform(88, 9);

        this.shape_45 = new cjs.Shape();
        this.shape_45.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_45.setTransform(71, 9);

        this.shape_46 = new cjs.Shape();
        this.shape_46.graphics.f("#FFFFFF").s().p("AhFA8IAAh3IAoAAIAAAUIAUAAIAAAUIgUAAIAAAnIA7AAIAAg7IgnAAIAAgUIA7AAIAAAUIAUAAIAAA7IgUAAIAAAUIhPAAIAAAUg");
        this.shape_46.setTransform(55, 10);

        this.shape_47 = new cjs.Shape();
        this.shape_47.graphics.f("#FFFFFF").s().p("AgxAyIAAgUIgUAAIAAg7IAUAAIAAgUIBjAAIAAAUIAUAAIAAA7IgUAAIAAAUgAgdAeIA7AAIAAg7Ig7AAg");
        this.shape_47.setTransform(39, 9);

        this.shape_48 = new cjs.Shape();
        this.shape_48.graphics.f("#FFFFFF").s().p("AAoBQIAAgUIhPAAIAAAUIgoAAIAAgoIAUAAIAAgoIAUAAIAAhPIBjAAIAAB3IAUAAIAAAogAgTAoIAnAAIAAhjIgnAAg");
        this.shape_48.setTransform(24, 8);

        this.timeline.addTween(cjs.Tween.get({}).to({ state: [{ t: this.shape_48 }, { t: this.shape_47 }, { t: this.shape_46 }, { t: this.shape_45 }, { t: this.shape_44 }, { t: this.shape_43 }, { t: this.shape_42 }, { t: this.shape_41 }, { t: this.shape_40 }, { t: this.shape_39 }, { t: this.shape_38 }, { t: this.shape_37 }, { t: this.shape_36 }, { t: this.shape_35 }, { t: this.shape_34 }, { t: this.shape_33 }, { t: this.shape_32 }, { t: this.shape_31 }, { t: this.shape_30 }, { t: this.shape_29 }, { t: this.shape_28 }, { t: this.shape_27 }, { t: this.shape_26 }, { t: this.shape_25 }, { t: this.shape_24 }, { t: this.shape_23 }, { t: this.shape_22 }, { t: this.shape_21 }, { t: this.shape_20 }, { t: this.shape_19 }, { t: this.shape_18 }, { t: this.shape_17 }, { t: this.shape_16 }, { t: this.shape_15 }, { t: this.shape_14 }, { t: this.shape_13 }, { t: this.shape_12 }, { t: this.shape_11 }, { t: this.shape_10 }, { t: this.shape_9 }, { t: this.shape_8 }, { t: this.shape_7 }, { t: this.shape_6 }, { t: this.shape_5 }, { t: this.shape_4 }, { t: this.shape_3 }, { t: this.shape_2 }, { t: this.shape_1 }, { t: this.shape }] }).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.text09, new cjs.Rectangle(0, 0, 366, 58), null);


    (lib.numinner = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // Layer_1
        this.textElement = new cjs.Text("00", "78px 'Press Start 2P'", "#FEE761");
        this.textElement.name = "textElement";
        this.textElement.textAlign = "center";
        this.textElement.lineHeight = 94;
        this.textElement.lineWidth = 352;
        this.textElement.parent = this;
        this.textElement.setTransform(0.1, 0);

        this.timeline.addTween(cjs.Tween.get(this.textElement).wait(1));

        this._renderFirstFrame();

    }).prototype = getMCSymbolPrototype(lib.numinner, new cjs.Rectangle(-178, -2, 356.2, 82), null);


    (lib.numwrapper = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = { "default": 0, "starts-with-1": 4 };
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // timeline functions:
        this.frame_0 = function () {
            this.stop();
        };
        this.frame_4 = function () {
            this.stop();
        };

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4).call(this.frame_4).wait(6));

        // Layer_1
        this.inner = new lib.numinner();
        this.inner.name = "inner";
        this.inner.setTransform(0.1, 45, 1, 1, 0, 0, 0, 0.1, 45);

        this.timeline.addTween(cjs.Tween.get(this.inner).wait(4).to({ x: -4.9 }, 0).wait(6));

        this._renderFirstFrame();

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-183, -2, 361.2, 82);


    (lib.coinsmc = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = true; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = { "length-2": 0, "length-3": 4, "length-4": 9 };
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        // timeline functions:
        this.frame_0 = function () {
            this.stop();
        };
        this.frame_4 = function () {
            this.stop();
        };
        this.frame_9 = function () {
            this.stop();
        };

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(4).call(this.frame_4).wait(5).call(this.frame_9).wait(5));

        // Layer_1_copy
        this.instance = new lib.Symbol1();
        this.instance.setTransform(182, -38, 1, 1, 0, 0, 180);
        this.instance._off = true;

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({ _off: false }, 0).wait(5).to({ x: 221 }, 0).wait(5));

        // Layer_1_copy_copy
        this.instance_1 = new lib.Symbol1();
        this.instance_1.setTransform(-185, -38);
        this.instance_1._off = true;

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({ _off: false }, 0).wait(5).to({ x: -223 }, 0).wait(5));

        // Layer_1
        this.instance_2 = new lib.coinsresultx2();
        this.instance_2.setTransform(-145, -38, 0.5, 0.5);

        this.timeline.addTween(cjs.Tween.get(this.instance_2).to({ _off: true }, 4).wait(10));

        this._renderFirstFrame();

    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(-223, -38, 444, 68);


    // stage content:
    (lib.shareimagetemplate = function (mode, startPosition, loop, reversed) {
        if (loop == null) { loop = false; }
        if (reversed == null) { reversed = false; }
        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = { "text-default": 0, "text-2": 1, "text-3": 2, "text-4": 3 };
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]);

        this.actionFrames = [0, 1, 2, 3];
        // timeline functions:
        this.frame_0 = function () {
            this.stop();
            this._defaultTextFrameLabel = 'text-default';
            this._validTextFrameLabels = [this._defaultTextFrameLabel, 'text-2', 'text-3', 'text-4'];
            this._firstCharToFrameLabelMap = {
                '1': 'starts-with-1',
                'default': 'default'
            };
            this._minNumTextLength = 2;
            this._maxNumTextLength = 4;

            function updateCoinsPosition(numLength) {
                numLength = Math.max(this._minNumTextLength, Math.min(numLength, this._maxNumTextLength));
                this.coins.gotoAndStop('length-' + numLength.toString(10));
            }

            function setNumText(num) {
                var prefix = num < 10 ? '0' : '';
                var numText = prefix + num.toString();
                var numFirstChar = numText.substring(0, 1);
                var label = this._firstCharToFrameLabelMap[numFirstChar] || this._firstCharToFrameLabelMap.default;

                if (label) {
                    this.numWrapper.gotoAndStop(label);
                }
                this.updateCoinsPosition(numText.length);
                this.numWrapper.inner.textElement.text = numText;
            }

            function setResult(num, textOption) {
                var label = this._validTextFrameLabels.includes(textOption) ? textOption : this._defaultTextFrameLabel;

                if (label) {
                    this.gotoAndStop(label);
                }
                this.setNumText(num);
            }

            this.setNumText = setNumText.bind(this);
            this.updateCoinsPosition = updateCoinsPosition.bind(this);
            this.setResult = setResult.bind(this);

            // EXAMPLE
            // this.setResult(1100, 'text-4');
        };
        this.frame_1 = function () {
            this.stop();
        };
        this.frame_2 = function () {
            this.stop();
        };
        this.frame_3 = function () {
            this.stop();
        };

        // actions tween:
        this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1).call(this.frame_2).wait(1).call(this.frame_3).wait(1));

        // TITLE
        this.instance = new lib.titlemc();
        this.instance.setTransform(594.1, 183, 1, 1, 0, 0, 0, 216.1, 24);

        this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({ y: 188 }, 0).wait(2));

        // num
        this.numWrapper = new lib.numwrapper();
        this.numWrapper.name = "numWrapper";
        this.numWrapper.setTransform(694.1, 304, 1, 1, 0, 0, 0, 90.1, 45);

        this.timeline.addTween(cjs.Tween.get(this.numWrapper).wait(2).to({ x: 695.1, y: 309 }, 0).wait(2));

        // text_39_copy
        this.instance_1 = new lib.text9999();
        this.instance_1.setTransform(595.5, 407, 1, 1, 0, 0, 0, 148, 18.5);
        this.instance_1._off = true;

        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(3).to({ _off: false }, 0).wait(1));

        // text_29_copy
        this.instance_2 = new lib.text999();
        this.instance_2.setTransform(594.5, 407, 1, 1, 0, 0, 0, 156, 18.5);
        this.instance_2._off = true;

        this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(2).to({ _off: false }, 0).to({ _off: true }, 1).wait(1));

        // text_19_copy
        this.instance_3 = new lib.text99();
        this.instance_3.setTransform(602.5, 396.5, 1, 1, 0, 0, 0, 159, 28);
        this.instance_3._off = true;

        this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({ _off: false }, 0).to({ _off: true }, 1).wait(2));

        // text_09_copy
        this.instance_4 = new lib.text09();
        this.instance_4.setTransform(602.5, 397.5, 1, 1, 0, 0, 0, 183, 29);

        this.timeline.addTween(cjs.Tween.get(this.instance_4).to({ _off: true }, 1).wait(3));

        // coins_x2
        this.coins = new lib.coinsmc();
        this.coins.name = "coins";
        this.coins.setTransform(600, 297);

        this.timeline.addTween(cjs.Tween.get(this.coins).wait(2).to({ x: 601, y: 303 }, 0).wait(2));

        // BGx2
        this.instance_5 = new lib.sharebackground();
        this.instance_5.setTransform(0, 0, 0.5, 0.5);

        this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(4));

        this._renderFirstFrame();

    }).prototype = p = new lib.AnMovieClip();
    p.nominalBounds = new cjs.Rectangle(600, 315, 600, 315);
    // library properties:
    lib.properties = {
        id: '6A0C9D3AEEF347F6BB054ED130C28BA3',
        width: 1200,
        height: 630,
        fps: 30,
        color: "#0105AC",
        opacity: 1.00,
        manifest: [
            { src: "images/coinsresultx2.png", id: "coinsresultx2" },
            { src: "images/sharebackground.png", id: "sharebackground" }
        ],
        preloads: []
    };



    // bootstrap callback support:

    (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function () { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()); };
    p.stop = function (ms) { if (ms) this.seek(ms); this.tickEnabled = false; };
    p.seek = function (ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); };
    p.getDuration = function () { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; };

    p.getTimelinePosition = function () { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['6A0C9D3AEEF347F6BB054ED130C28BA3'] = {
        getStage: function () { return exportRoot.stage; },
        getLibrary: function () { return lib; },
        getSpriteSheet: function () { return ss; },
        getImages: function () { return img; }
    };

    an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);
        for (var j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function (id) {
        return an.compositions[id];
    };


    an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW, lastH, lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();
        function resizeCanvas() {
            var w = lib.properties.width, h = lib.properties.height;
            var iw = window.innerWidth, ih = window.innerHeight;
            var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;
            if (isResp) {
                if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                    sRatio = lastS;
                }
                else if (!isScale) {
                    if (iw < w || ih < h)
                        sRatio = Math.min(xRatio, yRatio);
                }
                else if (scaleType == 1) {
                    sRatio = Math.min(xRatio, yRatio);
                }
                else if (scaleType == 2) {
                    sRatio = Math.max(xRatio, yRatio);
                }
            }
            domContainers[0].width = w * pRatio * sRatio;
            domContainers[0].height = h * pRatio * sRatio;
            domContainers.forEach(function (container) {
                container.style.width = w * sRatio + 'px';
                container.style.height = h * sRatio + 'px';
            });
            stage.scaleX = pRatio * sRatio;
            stage.scaleY = pRatio * sRatio;
            lastW = iw; lastH = ih; lastS = sRatio;
            stage.tickOnUpdate = false;
            stage.update();
            stage.tickOnUpdate = true;
        }
    };
    an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
            var stageChild = stage.getChildAt(0);
            if (!stageChild.paused || stageChild.ignorePause) {
                stageChild.syncStreamSounds();
            }
        }
    };
    an.handleFilterCache = function (event) {
        if (!event.paused) {
            var target = event.target;
            if (target) {
                if (target.filterCacheList) {
                    for (var index = 0; index < target.filterCacheList.length; index++) {
                        var cacheInst = target.filterCacheList[index];
                        if ((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)) {
                            cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                        }
                    }
                }
            }
        }
    };
})(createjs, AdobeAn = AdobeAn || {});

export { AdobeAn };
